"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MoreHoriz = _interopRequireDefault(require("@material-ui/icons/MoreHoriz"));
var _classnames = _interopRequireDefault(require("classnames"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _SingleConditionText = _interopRequireDefault(require("./components/SingleConditionText"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var baseContainer = {
    alignItems: 'center',
    borderRadius: '4px',
    display: 'flex',
    flexGrow: 1,
    height: 'auto',
    justifyContent: 'space-between',
    minHeight: '36px'
  };
  return {
    container: _objectSpread({}, baseContainer, {
      '&:focus': {
        borderColor: 'transparent',
        // Increasing size of border will increase the height of the div.
        // To get around this, we can emulate the border with a boxShadow.
        // `'box-sizing': 'border-box'` was not working.
        // https://stackoverflow.com/questions/19248985/how-to-prevent-shifting-when-changing-border-width
        boxShadow: "0 0 0 2px ".concat(theme.palette.primary[800])
      },
      '&:hover:not(:focus)': {
        border: '1px solid black'
      },
      backgroundColor: 'white',
      border: "1px solid ".concat(theme.palette.opacity.black[38]),
      padding: theme.spacing(1, 0.5, 1, 1.5)
    }),
    iconButton: {
      margin: theme.spacing(-1, 0, -1, 0.5) // 4px from Icon + 4px = 8px
    },

    statusDisabled: _objectSpread({}, baseContainer, {
      backgroundColor: theme.palette.opacity.black[8],
      border: "1px solid ".concat(theme.palette.grey[400]),
      padding: theme.spacing(1, 0.5, 1, 1.5)
    }),
    statusReadonly: _objectSpread({}, baseContainer, {
      backgroundColor: theme.palette.opacity.black[8],
      border: "1px solid ".concat(theme.palette.opacity.black[24]),
      padding: theme.spacing(1, 1.5)
    })
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_single_condition'
  },
  icon: /*#__PURE__*/_react["default"].createElement(_MoreHoriz["default"], null),
  multiline: false
};
var defaultIconButtonProps = {
  'aria-label': 'Condition Configuration',
  color: 'secondary'
};

/**
 * SingleCondition is a component to be used with the ConditionGroup component.
 * Its purpose is to display a single modifiable condition as part of a larger
 * workflow.
 */
var SingleCondition = function SingleCondition(props) {
  var _cx;
  var children = props.children,
    className = props.className,
    dataMetrics = props.dataMetrics,
    icon = props.icon,
    IconButtonProps = props.IconButtonProps,
    multiline = props.multiline,
    onIconButtonClick = props.onIconButtonClick,
    status = props.status,
    TypographyProps = props.TypographyProps,
    width = props.width;
  var styles = useStyles();
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var mergedIconButtonProps = _objectSpread({}, defaultIconButtonProps, {}, IconButtonProps);
  var containerRef = _react["default"].useRef(null);
  var iconButtonRef = _react["default"].useRef(null);
  var isDisabled = status === 'disabled';
  var isReadonly = status === 'readonly';
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-disabled": isDisabled,
    className: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, styles.container, !status), (0, _defineProperty2["default"])(_cx, styles.statusDisabled, isDisabled), (0, _defineProperty2["default"])(_cx, styles.statusReadonly, isReadonly), _cx), className),
    "data-metrics": mergedDataMetrics.root,
    onKeyUp: function onKeyUp(event) {
      if (isReadonly) {
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        iconButtonRef.current.focus();
      }
    },
    ref: containerRef,
    role: "document",
    style: {
      width: width
    },
    tabIndex: status ? '-1' : '0'
  }, /*#__PURE__*/_react["default"].createElement(_SingleConditionText["default"], {
    isDisabled: isDisabled,
    multiline: multiline,
    TypographyProps: TypographyProps
  }, children), !isReadonly && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({}, mergedIconButtonProps, {
    className: (0, _classnames["default"])(styles.iconButton, mergedIconButtonProps.className),
    disabled: isDisabled,
    ref: iconButtonRef,
    onClick: onIconButtonClick,
    onKeyUp: function onKeyUp(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        containerRef.current.focus();
      }
    }
  }), icon));
};
SingleCondition.defaultProps = defaultProps;
SingleCondition.displayName = 'SingleCondition';
SingleCondition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The label of the component.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The icon to display.
   */
  icon: _propTypes["default"].element,
  /**
   * Props to pass to the IconButton component.
   */
  IconButtonProps: _propTypes["default"].object,
  /**
   * If `true`, the text will wrap to a maximum of three lines before being
   * truncated.
   */
  multiline: _propTypes["default"].bool,
  /**
   * Callback fired when the IconButton is clicked.
   */
  onIconButtonClick: _propTypes["default"].func,
  /**
   * The status of the component.
   */
  status: _propTypes["default"].oneOf(['disabled', 'readonly']),
  /**
   * Props to pass to the Typography component.
   */
  TypographyProps: _propTypes["default"].object,
  /**
   * Manually set the width of the component.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
} : {};
var _default = SingleCondition;
exports["default"] = _default;